import type { Lesson } from '../../schema.js';

export const PIN_LESSONS: Lesson[] = [
  {
    id: 'puzzle-pin',
    slug: 'puzzles-pin',
    title: 'Pin attack',
    audienceLevel: 'beginner',
    concepts: ['puzzles'],
    steps: [
      {
        kind: 'explain',
        title: 'Freeze a piece',
        body: 'A pin is a piece that cannot move because it shields something more valuable behind it. Capture the pinned piece — it cannot run away.',
        narration: 'Capture the pinned piece.',
      },
      {
        kind: 'drill',
        task: 'best-move',
        title: 'The pinned knight',
        body: 'The black knight on e6 is pinned to the king. Capture it.',
        fen: 'r3k3/8/4n3/8/8/1B6/8/4R1K1 w - - 0 1',
        answer: ['Rxe6+', 'Bxe6'],
        solution: ['Rxe6+'],
        expect: 'win-material',
        tier: 1,
        hint: 'The knight shields the black king.',
        hintLadder: ['The knight shields the black king.', 'A pinned piece cannot move away.', 'Capture it with the rook or the bishop!'],
      },
      {
        kind: 'drill',
        task: 'best-move',
        title: 'The pinned rook',
        body: 'The black rook on g7 shields the king. Take it.',
        fen: '6k1/6r1/7K/8/8/8/8/6R1 w - - 0 1',
        answer: ['Rxg7+'],
        solution: ['Rxg7+'],
        expect: 'win-material',
        tier: 2,
        hint: 'The rook on g7 is pinned to the king.',
        hintLadder: ['The rook on g7 is pinned to the king.', 'Your rook can capture it safely.', 'Rxg7 wins the rook!'],
      },
      {
        kind: 'drill',
        task: 'best-move',
        title: 'The pinned knight (side)',
        body: 'The black knight on c3 shields the king. Capture it.',
        fen: '8/8/8/4k3/8/2n5/8/B5K1 w - - 0 1',
        answer: ['Bxc3+'],
        solution: ['Bxc3+'],
        expect: 'win-material',
        tier: 3,
        hint: 'The knight shields the king on e5.',
        hintLadder: ['The knight shields the king on e5.', 'Your bishop can capture it safely.', 'Bxc3 wins the knight!'],
      },
    ],
  },
];
